import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../../components/ui/Loader';
import DataGrid from '../../../../components/DataGrid';
import { checkNullValues, toDate } from '../../../../utils/utils';
import OverflowText from '../../../../components/ui/OverflowTooltip';
import { resetRetiredDocumentsData } from '../../../../ducks/advisoryGroup';

const DocumentDetailsModal = ({ show, onCancel }) => {
    const dispatch = useDispatch();

    const documentList = useSelector((state) => state.advisoryGroup?.retiredMemberDocumentDetails);

    const defaultSort = [
        {
            id: 'recordCreated',
            desc: true,
        },
    ];

    const columns = [
        {
            id: 'fileName',
            header: 'Document Name',
            accessorKey: 'fileName',
            accessorFn: (row) => checkNullValues(row.fileName),
            cell: ({ row, cell }) => (
                <OverflowText id={cell.id}>
                    {row.original.fileName}
                </OverflowText>
            ),
        },
        {
            id: 'contentType',
            header: 'Content Type',
            accessorKey: 'contentType',
        },
        {
            id: 'contentSubType',
            header: 'Sub Type',
            accessorKey: 'contentSubType',
        },
        {
            id: 'description',
            header: 'Description',
            accessorKey: 'description',
            accessorFn: (row) => checkNullValues(row.description),
            cell: ({ row, cell }) => (
                <OverflowText id={cell.id}>
                    {row.original.description}
                </OverflowText>),
            enableColumnFilter: false,
        },
        {
            id: 'agShortName',
            header: 'AG Short Name',
            accessorKey: 'agShortName',
        },
        {
            id: 'agMeetingTitle',
            header: 'AG Meeting Title',
            accessorKey: 'agMeetingTitle',
            cell: ({ row, cell }) => (
                row.original.agMeetingTitle ? <OverflowText id={cell.id}>{row.original.agMeetingTitle}</OverflowText> : ""
            ),
        },
        {
            id: 'recordCreated',
            header: 'Uploaded Date',
            accessorKey: 'recordCreated',
            sortType: 'date',
            accessorFn: (row) => (new Date(row.recordCreated)),
            cell: ({ row }) => `${toDate(row.original.recordCreated)}`,
            size: 150,
            enableColumnFilter: false,
            sortingFn: 'datetime'
        }
    ];

    const onHideCallback = () => {
        dispatch(resetRetiredDocumentsData());
        onCancel();
    };
    
    return (
        <div>
            <Modal
                show={show}
                fullscreen={false}
                backdrop="static"
                onHide={onHideCallback}
                size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Document Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {documentList === null ? (
                        <Loader />
                    ) : (
                        <DataGrid
                            columns={columns}
                            data={documentList}
                            sort={defaultSort}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default DocumentDetailsModal;
